export default __webpack_public_path__ + "static/media/MO.f6f65a2e.svg";